import { OnDestroy, Component } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  template: ''
})
export abstract class SubscriptionBaseComponent implements OnDestroy {

  subscription: Subscription = new Subscription();

  constructor() { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
